import { useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "@/context/CartContext";

const NAV_LINKS = [
  { label: "Home", href: "/gb/en/home.html", route: true },
  { label: "Lookbook", href: "/gb/en/lookbook.html", route: true },
  { label: "Shop", href: "/gb/en/home.html#shop" },
  { label: "Categories", href: "/gb/en/home.html#categories" },
  { label: "About", href: "/gb/en/home.html#about" },
  { label: "Reviews", href: "/gb/en/home.html#reviews" },
];

export const SiteHeader = () => {
  const { count, setOpen } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);

  const linkClass =
    "font-heading text-xs font-semibold uppercase tracking-[0.2em] text-zinc-600 transition-colors hover:text-tiger";

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-zinc-200 bg-white/85 backdrop-blur-md"
    >
      <div className="bg-ink px-4 py-1.5 text-center" data-testid="announcement-bar">
        <p className="font-heading text-[10px] font-semibold uppercase tracking-[0.25em] text-zinc-300">
          Free UK shipping over £50 <span className="text-tiger">✦</span> Printed on demand <span className="text-tiger">✦</span> Worldwide delivery
        </p>
      </div>
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-8 lg:px-12">
        <Link to="/gb/en/home.html" data-testid="header-logo-link" className="flex items-center gap-3">
          <img src="/assets/logo-black.png" alt="Tiger Clothing" className="h-11 w-auto" />
          <span className="hidden font-display text-lg uppercase tracking-widest text-zinc-900 sm:block">
            Tiger<span className="text-tiger">.</span>Clothing
          </span>
        </Link>

        <nav data-testid="main-nav" className="hidden items-center gap-8 lg:flex">
          {NAV_LINKS.map((link) =>
            link.route ? (
              <Link key={link.label} to={link.href} data-testid={`nav-${link.label.toLowerCase()}-link`} className={linkClass}>
                {link.label}
              </Link>
            ) : (
              <a key={link.label} href={link.href} data-testid={`nav-${link.label.toLowerCase()}-link`} className={linkClass}>
                {link.label}
              </a>
            )
          )}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="cart-open-button"
            onClick={() => setOpen(true)}
            className="relative flex h-10 w-10 items-center justify-center border border-zinc-300 text-zinc-900 transition-colors hover:border-tiger hover:text-tiger"
            aria-label="Open cart"
          >
            <ShoppingBag size={18} />
            {count > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -right-2 -top-2 flex h-5 min-w-5 items-center justify-center bg-tiger px-1 font-heading text-[10px] font-bold text-black"
              >
                {count}
              </span>
            )}
          </button>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center border border-zinc-300 text-zinc-900 lg:hidden"
            aria-label="Toggle menu"
          >
            {menuOpen ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav data-testid="mobile-nav" className="border-t border-zinc-200 bg-white px-4 py-4 lg:hidden">
          <div className="flex flex-col gap-4">
            {NAV_LINKS.map((link) =>
              link.route ? (
                <Link
                  key={link.label}
                  to={link.href}
                  data-testid={`mobile-nav-${link.label.toLowerCase()}-link`}
                  onClick={() => setMenuOpen(false)}
                  className="font-heading text-sm font-semibold uppercase tracking-[0.2em] text-zinc-700 hover:text-tiger"
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.label}
                  href={link.href}
                  data-testid={`mobile-nav-${link.label.toLowerCase()}-link`}
                  onClick={() => setMenuOpen(false)}
                  className="font-heading text-sm font-semibold uppercase tracking-[0.2em] text-zinc-700 hover:text-tiger"
                >
                  {link.label}
                </a>
              )
            )}
          </div>
        </nav>
      )}
    </header>
  );
};
